module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-manual-wrap"
  }, [_c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userBarcode')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改條碼\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userPassword')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改密碼\n    ")])]), _vm._v(" "), (_vm.$store.state.generalSetting.can_login_with_fingerprinter) ? _c('div', {
    staticClass: "function-button d-inline-block",
    on: {
      "click": function($event) {
        return _vm.goto('userFingerprint')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_vm._v("\n      更改指紋\n    ")])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/barcode.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/key.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon-wrap"
  }, [_c('img', {
    attrs: {
      "src": "/static/svg/fingerprint.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38055812","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserManual/Index.vue
// module id = 1431
// module chunks = 1